export default "__VITE_ASSET__BV4YJ6J___"